import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcDoneFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.028 6.681a1.67 1.67 0 0 1 2.362 2.363l-9.06 9.06a1.5 1.5 0 0 1-2.121 0l-5.354-5.353a1.492 1.492 0 1 1 2.11-2.11l3.91 3.91a.2.2 0 0 0 .283 0z",
    clipRule: "evenodd"
  }));
}
var IcDoneFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcDoneFill));

export { IcDoneFill as I };
